import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
const { wrapHOC } = FrameworkUtils;
import { userSelector } from 'selectors/user/userSelector';

import { isSplitEDDEnabledSelector } from 'viewModel/selectors/checkout/isSplitEDDEnabled/isSplitEDDEnabledSelector';
import { orderSelector } from 'selectors/order/orderSelector';

const fields = createSelector(isSplitEDDEnabledSelector, orderSelector, userSelector, (isSplitEDDEnabled, order, user) => {
    const isUserOptedIn = user?.smsStatus?.isUserOptedIn || false;

    return {
        isSplitEDDEnabled,
        splitEDDExperienceDisplayed: order.splitEDDExperienceDisplayed,
        isUserOptedIn
    };
});

const withOrderDetailProps = wrapHOC(connect(fields));

export {
    fields, withOrderDetailProps
};
